/* Manual looping carousel. Editorial content remains in each template. */
(() => {
  if (window.localFireFormatsLoaded) return;
  window.localFireFormatsLoaded = true;
  const instances = new Map();

  function init(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('.ltf__track');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('.ltf__card'));
    if (!cards.length) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const prev = root.querySelector('.ltf__nav--prev');
    const next = root.querySelector('.ltf__nav--next');
    const count = cards.length > 1 ? Math.min(5, cards.length) : 0;
    const clones = [];
    let timer, highlightTimer, frame;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = () => motion.matches ? 'auto' : 'smooth';

    function clone(card) {
      const copy = card.cloneNode(true);
      copy.classList.add('ltf__clone');
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('role');
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
      clones.push(copy);
      return copy;
    }
    const before = document.createDocumentFragment();
    const after = document.createDocumentFragment();
    if (count) {
      cards.slice(-count).forEach(card => before.appendChild(clone(card)));
      cards.slice(0, count).forEach(card => after.appendChild(clone(card)));
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
    }

    const step = () => cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12);
    const start = () => cards[0].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - 6;
    function jump(left) {
      const oldBehavior = track.style.scrollBehavior;
      const oldSnap = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      void track.offsetHeight;
      track.style.scrollBehavior = oldBehavior;
      track.style.scrollSnapType = oldSnap;
    }
    function normalize() {
      if (!count) return;
      const first = start();
      const span = cards.length * step();
      if (track.scrollLeft < first - step() / 2) jump(track.scrollLeft + span);
      else if (track.scrollLeft >= first + span - step() / 2) jump(track.scrollLeft - span);
    }
    function move(direction) {
      normalize();
      track.scrollBy({ left: direction * step(), behavior: behavior() });
    }
    [prev, next].forEach(button => { if (button) button.disabled = cards.length < 2; });
    if (prev) prev.addEventListener('click', () => move(-1), { signal });
    if (next) next.addEventListener('click', () => move(1), { signal });
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }, { signal });
    track.addEventListener('scroll', () => {
      if (next) next.classList.remove('ltf__nav--pulse');
      clearTimeout(timer);
      timer = setTimeout(normalize, 120);
    }, { passive: true, signal });
    track.addEventListener('click', event => {
      const chip = event.target.closest('.ltf__chip[data-chip]');
      if (!chip || !track.contains(chip)) return;
      track.querySelectorAll('.is-highlight').forEach(card => card.classList.remove('is-highlight'));
      const card = chip.closest('.ltf__card');
      if (!card) return;
      card.classList.add('is-highlight');
      clearTimeout(highlightTimer);
      highlightTimer = setTimeout(() => card.classList.remove('is-highlight'), 1500);
    }, { signal });
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => jump(start()));
    }, { signal });
    frame = requestAnimationFrame(() => jump(start()));
    instances.set(root, () => {
      abort.abort();
      clearTimeout(timer);
      clearTimeout(highlightTimer);
      cancelAnimationFrame(frame);
      clones.forEach(copy => copy.remove());
      instances.delete(root);
    });
  }
  function scan(surface = document) {
    if (surface.matches && surface.matches('[data-local-fire-formats]')) init(surface);
    surface.querySelectorAll('[data-local-fire-formats]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    Array.from(instances).forEach(([root, dispose]) => { if (event.target.contains(root)) dispose(); });
  });
})();
